export default __webpack_public_path__ + "img/Image-403.6183f60846d1ea175f64bbaea784da3d.png";